import Alpine from "alpinejs";
import axios from "axios";
import { stringify } from "qs";
import { bind_swiper } from "../integration/swiper";

const { is_mobile_device } = window.tg;

// Get the property id
const reviews_filter_sort_div = document.querySelector(
    "#reviews_filter_sort_div"
);
let property_id = "";
if (reviews_filter_sort_div) {
    property_id = reviews_filter_sort_div.getAttribute("data-eid");
}

export function filterPropertyReviews(params) {
    cleatFilterPills();
    toggleLoader("show", "#loader-container-filter-sort");
    const current_review_ids = getCurrentReviewIDs();
    const active_sort = Alpine.store('review').sort_type;

    axios({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "post",
        url: "/backend/accommodation/filter_sort_reviews",
        data: stringify({
            property_id: property_id,
            review_score: params.review_score,
            months: params.review_months,
            traveller_type: params.review_traveller_type,
            duration: params.review_duration,
            units: params.units,
            current_review_ids: current_review_ids,
            sort_type : active_sort,
        }),
    })
        .then((response) => {
            return response;
        })
        .then((output) => {
            if (output.data && output.data.success) {
                const html = output.data.data.html;
                let reviews_container =
                    document.querySelector("#reviews-container");

                // Replace the reviews container with the new HTML
                let parentElement = reviews_container.parentNode;
                let newDiv = document.createElement("div");
                newDiv.innerHTML = html;
                parentElement.replaceChild(newDiv, reviews_container);
                reviews_container = newDiv;

                addLoadMoreEventListener();
                reloadEvents();
            }
        })
        .catch((error) => {
            toggleLoader("hide", "#loader-container-filter-sort");
        });
}

export function sortReviews(sort_type) {
    toggleLoader("show", "#loader-container-filter-sort");
    const active_filters = getActiveFilters();
    const current_review_ids = getCurrentReviewIDs();
    axios({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "post",
        url: "/backend/accommodation/filter_sort_reviews",
        data: stringify({
            property_id: property_id,
            sort_type: sort_type,
            current_review_ids: current_review_ids,
            active_filters: active_filters,
        }),
    })
        .then((response) => {
            return response;
        })
        .then((output) => {
            if (output.data && output.data.success) {
                const html = output.data.data.html;

                // Replace the reviews container with the new HTML
                let reviews_container =
                    document.querySelector("#reviews-container");
                let parentElement = reviews_container.parentNode;
                let newDiv = document.createElement("div");
                newDiv.innerHTML = html;
                parentElement.replaceChild(newDiv, reviews_container);
                reviews_container = newDiv;

                // Set sort type
                Alpine.store('review').sort_type = sort_type;

                addLoadMoreEventListener();
                reloadEvents();
            }
        })
        .catch((error) => {
            toggleLoader("hide", "#loader-container-filter-sort");
        });
}

function addLoadMoreEventListener() {
    const loadMoreButton = document.getElementById("load-more-reviews");
    if (!loadMoreButton) return; // Exit if button not found
    const activeFilters = getActiveFilters();
    const active_sort = Alpine.store('review').sort_type;

    loadMoreButton.addEventListener("click", function () {
        toggleLoader("show", "#loader-container-show-more");
        const existingReviewIDs = Array.from(
            document.querySelectorAll("#review-snippet-parent [data-eid]")
        ).map((element) => element.getAttribute("data-eid"));
        axios({
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            method: "post",
            url: "/backend/accommodation/get_more_reviews",
            data: stringify({
                property_id: property_id,
                current_review_ids: existingReviewIDs,
                active_filters: activeFilters,
                active_sort : active_sort,
            }),
        })
            .then((response) => {
                return response;
            })
            .then((output) => {
                if (output.data && output.data.success) {
                    const html = output.data.data.html;

                    // Replace the reviews container with the new HTML
                    let reviews_container =
                        document.querySelector("#reviews-container");
                    let parentElement = reviews_container.parentNode;
                    let newDiv = document.createElement("div");
                    newDiv.innerHTML = html;
                    parentElement.replaceChild(newDiv, reviews_container);
                    reviews_container = newDiv;

                    // Re-add the event listener after updating the content
                    addLoadMoreEventListener();
                    reloadEvents();
                }
            })
            .catch((error) => {
                toggleLoader("hide", "#loader-container-show-more");
            });
    });
}

function cleatFilterPills() {
    const filterPills = document.querySelector("#filter-display-bar");
    filterPills.innerHTML = "";
}

function getCurrentReviewIDs() {
    return Array.from(
        document.querySelectorAll("#review-snippet-parent [data-eid]")
    ).map((element) => element.getAttribute("data-eid"));
}

function toggleLoader(action, ID) {
    const loaderContainer = document.querySelector(ID);
    if (action === "show") {
        loaderContainer.classList.remove("d-none");
    } else if (action === "hide") {
        loaderContainer.classList.add("d-none");
    }
}

const filterOptionsHandler = () => {
    // TO-DO: Comment out filter pills for now, will re-implement as an improvement

    //select all filter options
    const filterOptions = document.querySelectorAll(".review-filter-option");

    // select filter pills to filter-display-bar
    const filterDisplayBar = document.getElementById("filter-display-bar");

    // add option to total filter count if input is checked and not already in activeFilters array
    filterOptions.forEach((option) => {
        if (
            option.checked &&
            !Alpine.store("general").activeFilters.includes(option.value)
        ) {
            Alpine.store("general").filterCount++;
            // create filter pill elements
            const filterPill = document.createElement("div");
            const filterName = document.createElement("p");
            const xmarkIcon = '<i class="fa fa-xmark"></i>';
            filterPill.classList.add("filter-pill");
            filterPill.setAttribute("data-filter-value", option.value);
            filterName.innerHTML = xmarkIcon + " " + option.name;
            filterDisplayBar.appendChild(filterPill);
            filterPill.appendChild(filterName);

            // add filter option value to activeFilters array
            Alpine.store("general").activeFilters.push(option.value);
        }
    });

    // remove filter pill from filter-display-bar and activeFilters array if xmark is clicked
    const filterPills = document.querySelectorAll(".filter-pill");
    filterPills.forEach((pill) => {
        pill.addEventListener("click", () => {
            pill.remove();
            if (
                Alpine.store("general").activeFilters.includes(
                    pill.getAttribute("data-filter-value")
                )
            ) {
                Alpine.store("general").activeFilters = Alpine.store(
                    "general"
                ).activeFilters.filter(
                    (filter) =>
                        filter !== pill.getAttribute("data-filter-value")
                );
            }
        });
    });
}

function getActiveFilters() {
    const filterDisplayBar = document.getElementById("filter-display-bar");
    const filterPills = filterDisplayBar.querySelectorAll(".filter-pill");
    const categoryValuesMap = {};

    filterPills.forEach((pill) => {
        const category = pill.getAttribute("data-filter-category");
        const value = pill.getAttribute("data-filter-value");
        if (!categoryValuesMap[category]) {
            categoryValuesMap[category] = [];
        }
        categoryValuesMap[category].push(value);
    });

    // Transform the map into the desired array format
    const resultArray = Object.keys(categoryValuesMap).map((category) => {
        return { [category]: categoryValuesMap[category] };
    });

    return resultArray;
}

// Function to toggle visibility
function toggleVisibility(element) {
    if (element.style.display === "none" || element.style.display === "") {
        element.style.display = "block";
    } else {
        element.style.display = "none";
    }
}

// Ensure the DOM is fully loaded before running the script
document.addEventListener("DOMContentLoaded", function () {
    const navPriceboxFixed = document.getElementById('js-navpricebox-fixed');
    const languageOverlay = document.getElementById('js-language-overlay');
    const titleBox = document.getElementById('js-title-box');

    if (navPriceboxFixed && titleBox) {
        const observerOptions = {
            root: null, // Use the viewport as the root
            rootMargin: '0px',
            threshold: 0 // Trigger when even one pixel is visible
        };

        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    navPriceboxFixed.classList.remove('d-lg-block');
                    if (languageOverlay) {
                        languageOverlay.classList.remove('d-lg-none');
                    }
                } else {
                    const boundingRect = entry.boundingClientRect;
                    if (boundingRect.top < 0) {
                        navPriceboxFixed.classList.add('d-lg-block');
                        if (languageOverlay) {
                            languageOverlay.classList.add('d-lg-none');
                        }
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(titleBox);
    }
});

export function checkSelectedInputs(inputs) {
    const filterPillDisplay = document.querySelector('#filter-display-bar');
    const filterPills = filterPillDisplay.querySelectorAll('div.filter-pill');

    // New code to extract data-filter-value and text content
    const resultArray = Array.from(filterPills).map(pill => {
        const dataFilterValue = pill.getAttribute('data-filter-value');
        const textContent = pill.querySelector('p')?.textContent?.trim() ?? "";
        const cleanedText = textContent.split('(')[0].trim();
        return { [cleanedText]: dataFilterValue };
    });

    inputs.forEach(input => {
        // Check if the input's name and value match any object in the filterOptions array
        const isOptionToCheck = resultArray.some(option => {
            const key = Object.keys(option)[0];
            const value = option[key];

            let isNormalCheckboxActive = (input.name.toLowerCase() === key.toLowerCase() && input.value.toLowerCase() === value.toLowerCase())
            let isUnitCheckboxActive = key.toLowerCase() === input.value.toLowerCase()

            return (isNormalCheckboxActive || isUnitCheckboxActive);;
        });

        if (isOptionToCheck) {
            input.checked = true;
        }
    });
}

export function reloadEvents() {

    // For the showing and hiding of long review messages
    const collapseNodeListAnchorsReviewMessage = /** @type {NodeListOf<HTMLAnchorElement>} */ (
        document.querySelectorAll("#review-message a[data-toggle='collapse']")
    );

    if (collapseNodeListAnchorsReviewMessage && collapseNodeListAnchorsReviewMessage.length > 0) {
        collapseNodeListAnchorsReviewMessage.forEach(anchor => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();

                const reviewMessageId = anchor.getAttribute('href').substring(1);
                const reviewMessageElement = document.getElementById(reviewMessageId);

                if (anchor.getAttribute("aria-expanded") === "true") {
                    anchor.setAttribute("aria-expanded", "false");
                    anchor.innerHTML = anchor.dataset.more != null ? anchor.dataset.more : _t('kd.estab.see_more', 'See more');
                    reviewMessageElement.classList.remove('show');
                } else {
                    anchor.setAttribute("aria-expanded", "true");
                    anchor.innerHTML = anchor.dataset.less != null ? anchor.dataset.less : _t('kd.estab.see_less', 'See less');
                    reviewMessageElement.classList.add('show');
                }
            });
        });
    }

    // For the showing and hiding of host response
    const collapseNodeListAnchorsHostResponse = /** @type {NodeListOf<HTMLAnchorElement>} */ (
        document.querySelectorAll("#host-response a[data-toggle='collapse']")
    );

    if (collapseNodeListAnchorsHostResponse && collapseNodeListAnchorsHostResponse.length > 0) {
        collapseNodeListAnchorsHostResponse.forEach((anchor) => {
            anchor.addEventListener("click", (event) => {
                event.preventDefault();
                const targetId = anchor.getAttribute("href").substring(1); // Get the target ID from href
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    if (targetElement.style.display === "none" || targetElement.style.display === "") {
                        targetElement.style.display = "block";
                        anchor.innerHTML = _t('kd.estab.hide_host_response', 'Hide host response');
                    } else {
                        targetElement.style.display = "none";
                        anchor.innerHTML = _t('kd.estab.view_host_response', 'View host response');
                    }
                }
            });
        });
    }

    // For showing and hiding the showing translated host response
    document.querySelectorAll("#host-response-translation-button").forEach(button => {
        button.addEventListener('click', function () {
            const reviewId = button.getAttribute("data");
            const englishResponse = document.getElementById(`translated-host-response-${reviewId}`);
            const originalResponse = document.getElementById(`original-host-response-${reviewId}`);
            const translationText = document.getElementById(`host-response-translation-${reviewId}`);

            if (englishResponse && originalResponse) {
                if (englishResponse.style.display === "none" || englishResponse.style.display === "") {
                    englishResponse.style.display = "block";
                    originalResponse.style.setProperty("display", "none", "important");
                    button.innerHTML = '<u>Show original</u>';
                    translationText.textContent = 'This review has been automatically translated using Google.';
                } else {
                    englishResponse.style.display = "none";
                    originalResponse.style.setProperty("display", "block", "important");
                    button.innerHTML = '<u>Translate to English</u>';
                    translationText.textContent = 'This review is displayed in its original language.';
                }
            }
        });
    });

    // For showing and hiding the original and hiding the translated guest response
    document.querySelectorAll("#translation-button").forEach(button => {
        button.addEventListener('click', function () {
            const reviewId = button.getAttribute("data");
            const englishReview = document.getElementById(`translated-review-${reviewId}`);
            const originalReview = document.getElementById(`original-review-${reviewId}`);
            const translationText = document.getElementById(`review-translation-${reviewId}`);

            if (englishReview && originalReview) {

                // Use getComputedStyle style to get style directly from css rather than the inline styling
                const computedStyle = window.getComputedStyle(englishReview);
                if (englishReview.style.display === "none" || englishReview.style.display === "" && computedStyle.display === "none") {
                    englishReview.style.display = "block";
                    originalReview.style.setProperty("display", "none", "important");;
                    button.innerHTML = '<u>Show original</u>';
                    translationText.textContent = 'This review has been automatically translated using Google.';
                } else {
                    englishReview.style.display = "none";
                    originalReview.style.setProperty("display", "block", "important");
                    button.innerHTML = '<u>Translate to English</u>';
                    translationText.textContent = 'This review is displayed in its original language.';
                }
            }
        });
    });

    // Re-apply the Intersection Observer logic
    const navPriceboxFixed = document.getElementById('js-navpricebox-fixed');
    const languageOverlay = document.getElementById('js-language-overlay');
    const titleBox = document.getElementById('js-title-box');

    if (navPriceboxFixed && titleBox) {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };

        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    navPriceboxFixed.classList.remove('d-lg-block');
                    if (languageOverlay) {
                        languageOverlay.classList.remove('d-lg-none');
                    }
                } else {
                    const boundingRect = entry.boundingClientRect;
                    if (boundingRect.top < 0) {
                        navPriceboxFixed.classList.add('d-lg-block');
                        if (languageOverlay) {
                            languageOverlay.classList.add('d-lg-none');
                        }
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(titleBox);
    }

    // Re-initialise unit display swiper
    const unitDisplaySwiper = document.querySelector('.js-swiper-peek')

    const unitsSwiperConfig = {
        spaceBetween: 8,
        loop: false,
        slidesPerView: is_mobile_device ? 1.5 : 3.2,
    }

    if (unitDisplaySwiper) {
        new Swiper('.js-swiper-peek', Object.assign(unitsSwiperConfig));
    }

}
